/**
 * @generated SignedSource<<c61907ec8c392bcb872c1b38e8c23b1f>>
 * @relayHash fe80a1b2e33f6eff925ae76caa91f105
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77318fdac91d7f2fd12e01a7775ae38d519bf4886382c8a8e848352e0669a097

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "77318fdac91d7f2fd12e01a7775ae38d519bf4886382c8a8e848352e0669a097",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
